import { featureRoute } from './feature';

export const allFeatureRoutes = [featureRoute()];
